import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IFileStore {
	fileId?: string;
	fileType?: {
		value: string;
		label: string;
	};
}

const initialState: IFileStore = {};

const fileSlice = createSlice({
	name: "files",
	initialState,
	reducers: {
		setFileStore(_, action: PayloadAction<IFileStore>) {
			return action.payload;
		},
		setFileType(state, action: PayloadAction<{ value: string; label: string }>) {
			state.fileType = action.payload;
		},
		resetFileState: () => initialState,
	},
});

export const { setFileStore, setFileType, resetFileState } = fileSlice.actions;

export default fileSlice.reducer;
